(() => {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const cartUrl = root.replace(/\/?$/, '/') + 'cart';
  const fastSelectors = [
    'shopify-accelerated-checkout',
    'shopify-accelerated-checkout-cart',
    '.shopify-payment-button',
    '.additional-checkout-buttons',
    '.cart__additional-checkout-buttons',
    '[data-shopify="payment-button"]'
  ].join(',');

  /* V298: rýchla platba (Apple Pay / Google Pay) je povolená IBA v košíku
     v kontajneri [data-ao-express], a to až keď je vybraná doprava.
     Kontajner odkrýva assets/ao-cart-v298.js. Všade inde ostáva vypnutá,
     aby nikto neobišiel výber Z-BOXu. */
  function isAllowedExpress(node) {
    if (!(node instanceof Element)) return false;
    const box = node.closest('[data-ao-express]');
    return Boolean(box && !box.hidden && box.dataset.aoExpressReady === 'true');
  }

  function inExpressBox(node) {
    return node instanceof Element && Boolean(node.closest('[data-ao-express]'));
  }

  function disableFastCheckout(scope = document) {
    const nodes = [];
    if (scope instanceof Element && scope.matches(fastSelectors)) nodes.push(scope);
    if (scope.querySelectorAll) nodes.push(...scope.querySelectorAll(fastSelectors));
    nodes.forEach((node) => {
      if (inExpressBox(node)) return;
      node.hidden = true;
      node.setAttribute('aria-hidden', 'true');
      node.setAttribute('inert', '');
      node.style.setProperty('display', 'none', 'important');
    });
  }

  function isCartCheckoutControl(element) {
    if (!(element instanceof Element)) return false;
    return Boolean(element.closest('.cart-drawer, .ao-cart-page, .main-cart, #cart-form'));
  }

  function isCheckoutUrl(raw) {
    if (!raw) return false;
    try {
      const url = new URL(raw, window.location.origin);
      const path = url.pathname.toLowerCase();
      return /\/checkouts?(?:\/|$)/.test(path);
    } catch (_) {
      return /\/checkouts?(?:[/?#]|$)/i.test(String(raw));
    }
  }

  function goToCart() {
    if (window.location.pathname.replace(/\/+$/, '') === cartUrl.replace(window.location.origin, '').replace(/\/+$/, '')) return;
    window.location.assign(cartUrl);
  }

  // Any normal link that tries to bypass the cart is redirected to the cart.
  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;

    const fast = target.closest(fastSelectors);
    if (fast) {
      if (isAllowedExpress(fast)) return;
      event.preventDefault();
      event.stopPropagation();
      if (typeof event.stopImmediatePropagation === 'function') event.stopImmediatePropagation();
      return;
    }

    const link = target.closest('a[href]');
    if (!link || isCartCheckoutControl(link) || !isCheckoutUrl(link.getAttribute('href'))) return;
    event.preventDefault();
    event.stopPropagation();
    goToCart();
  }, true);

  // Fallback for buttons/forms from third-party blocks that submit directly
  // to checkout. The guarded cart's own checkout submit is explicitly allowed.
  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement ? event.target : null;
    if (!form || isCartCheckoutControl(form)) return;

    const submitter = event.submitter instanceof Element ? event.submitter : null;
    const directSubmitter = submitter && String(submitter.getAttribute('name') || '').toLowerCase() === 'checkout';
    const directAction = isCheckoutUrl(form.getAttribute('action'));
    const returnTo = form.querySelector('input[name="return_to"]');
    const directReturn = returnTo && isCheckoutUrl(returnTo.value);

    if (!directSubmitter && !directAction && !directReturn) return;
    event.preventDefault();
    event.stopPropagation();
    goToCart();
  }, true);

  disableFastCheckout();

  /* V147: observer sleduje iba pridané uzly a prácu zbiera do jedného rámca.
     Zadanie /checkout do adresného riadka NEVIE zablokovať žiadny kód témy. */
  let pending = [];
  let frame = 0;

  const flush = () => {
    frame = 0;
    const batch = pending;
    pending = [];
    batch.forEach((node) => {
      if (node.isConnected) disableFastCheckout(node);
    });
  };

  const observer = new MutationObserver((records) => {
    for (const record of records) {
      if (!record.addedNodes.length) continue;
      for (const node of record.addedNodes) {
        if (node instanceof Element) pending.push(node);
      }
    }
    if (pending.length && !frame) frame = requestAnimationFrame(flush);
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
